export default __webpack_public_path__ + "static/media/marvel.afaa90e4.jpeg";